import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'

// import levelLocations from '@/pages/merchant/levelLocations.json'

export class LocationService extends BaseService {
  static async getRegionList(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.region-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getCityList(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.city-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async mockingLocations(controllingLocCodes = [], level) {
    try {
      const { data: levelLocations } = await this.request().get('/mock/levelLocations.json')
      const allLocations = await Promise.resolve(
        levelLocations.data.filter(s => s.level === Number(level))
      )
      const response = allLocations.filter(loc =>
        controllingLocCodes.some(controlLocCode => loc.code.startsWith(controlLocCode))
      )
      return response
    } catch (error) {
      const message =
        error.response && error.response.data ? error.response.data.error : error.message
      throw new ErrorWrapper(error, message)
    }
  }

  static async getLocationAllLevel(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.location.get-all-by-level'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListOnboardRegion(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.location.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async EditOnboard(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.location.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAfsList(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.get-list-work-as'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
